import api from "../api/axiosConfig";

const authService = {
  createUser: (data) => api.post("/createUser", data),
  getMe: () => api.get("/me"),
};

export default authService;
